module.exports = __webpack_public_path__ + "img/visa-card.58b752a8.svg";